import API from 'services/API/index';

export default function getSelfInsuranceTaxes() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/selfPaidInsuranceTaxes',
  });
}
